import React from "react";

const Img = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.10487 6.0112C9.37488 6.06906 9.54686 6.33486 9.489 6.60487L9.19005 8H11.6667L12.0103 6.39539C12.0682 6.12537 12.3339 5.95336 12.604 6.01119C12.874 6.06902 13.046 6.3348 12.9882 6.60482L12.6893 8H13.5C13.7761 8 14 8.22386 14 8.5C14 8.77614 13.7761 9 13.5 9H12.4752L12.0468 11H13C13.2761 11 13.5 11.2239 13.5 11.5C13.5 11.7761 13.2761 12 13 12H11.8326L11.489 13.6043C11.4312 13.8744 11.1654 14.0464 10.8954 13.9885C10.6254 13.9307 10.4534 13.6649 10.5112 13.3949L10.8099 12H8.3329L7.989 13.6049C7.93114 13.8749 7.66535 14.0469 7.39534 13.989C7.12533 13.9311 6.95334 13.6654 7.0112 13.3953L7.3102 12H6.5C6.22386 12 6 11.7761 6 11.5C6 11.2239 6.22386 11 6.5 11H7.52449L7.95306 9H7C6.72386 9 6.5 8.77614 6.5 8.5C6.5 8.22386 6.72386 8 7 8H8.16735L8.5112 6.39534C8.56906 6.12533 8.83486 5.95334 9.10487 6.0112ZM8.54719 11H11.0241L11.4525 9H8.97576L8.54719 11Z"
        fill="#fff"
      />
      <path
        d="M3 5.5C3 4.11929 4.11929 3 5.5 3H14.5C15.8807 3 17 4.11929 17 5.5V14.5C17 15.8807 15.8807 17 14.5 17H5.5C4.11929 17 3 15.8807 3 14.5V5.5ZM5.5 4C4.67157 4 4 4.67157 4 5.5V14.5C4 15.3284 4.67157 16 5.5 16H14.5C15.3284 16 16 15.3284 16 14.5V5.5C16 4.67157 15.3284 4 14.5 4H5.5Z"
        fill="#fff"
      />
      <path
        d="M11.4525 29L11.0241 31H8.54719L8.97576 29H11.4525Z"
        fill="#fff"
      />
      <path
        d="M5.5 23C4.11929 23 3 24.1193 3 25.5V34.5C3 35.8807 4.11929 37 5.5 37H14.5C15.8807 37 17 35.8807 17 34.5V25.5C17 24.1193 15.8807 23 14.5 23H5.5ZM9.10487 26.0112C9.37488 26.0691 9.54686 26.3349 9.489 26.6049L9.19005 28H11.6667L12.0103 26.3954C12.0682 26.1254 12.3339 25.9534 12.604 26.0112C12.874 26.069 13.046 26.3348 12.9882 26.6048L12.6893 28H13.5C13.7761 28 14 28.2239 14 28.5C14 28.7761 13.7761 29 13.5 29H12.4752L12.0468 31H13C13.2761 31 13.5 31.2239 13.5 31.5C13.5 31.7761 13.2761 32 13 32H11.8326L11.489 33.6043C11.4312 33.8744 11.1654 34.0464 10.8954 33.9885C10.6254 33.9307 10.4534 33.6649 10.5112 33.3949L10.8099 32H8.3329L7.989 33.6049C7.93114 33.8749 7.66535 34.0469 7.39534 33.989C7.12533 33.9311 6.95334 33.6654 7.0112 33.3953L7.3102 32H6.5C6.22386 32 6 31.7761 6 31.5C6 31.2239 6.22386 31 6.5 31H7.52449L7.95306 29H7C6.72386 29 6.5 28.7761 6.5 28.5C6.5 28.2239 6.72386 28 7 28H8.16735L8.5112 26.3953C8.56906 26.1253 8.83486 25.9533 9.10487 26.0112Z"
        fill="#fff"
      />
    </svg>
  );
};

export default Img;
